enum Cell {
  FirstPlayer = "1 pl",
  SecondPlayer = "2 pl",
  Empty = "empty"
}

export default Cell;